import { useSyncExternalStore } from "react";
import { getAuthState, subscribeAuth, type AuthState } from "@/lib/auth";

/**
 * React hook that subscribes to the global auth store. Backed by
 * `useSyncExternalStore` — no extra deps, plays nicely with Suspense /
 * concurrent rendering.
 */
export function useAuth(): AuthState {
  return useSyncExternalStore(subscribeAuth, getAuthState, getAuthState);
}
